import httpClient from "../../../services/http";

export const getHelpMenuItems = (data) =>
    httpClient.get('/utils-service/menu/help', { dispatch: data.dispatch });

export default httpClient;
